﻿import { defineComponent, inject, onMounted, ref } from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
    name: "StoresB2E",

    props: {
        webSite: {
            type: String,
            required: true,
        },
    },
    components: {},
    setup() {
        const compId = inject("compId", "");
        const usrId = inject("usrId", "");
        const b2eInfo = ref([{}]);


        const getFooterInfo = () => {
            var DataInfo = {
                comp_id: compId.value,
                USR_ID: usrId.value
            };
            window.AjaxPostLite("GetFooterForB2E", DataInfo, (res) => {
                if (res.MSG == null) {
                    b2eInfo.value = res.DATA.enties.B2EInfo;
                } else {
                    window.ShowDialog("error", "", res.MSG);
                }
                
            });
        }

        onMounted(() => {
            getFooterInfo();
        });

        return { b2eInfo };
    },
    template: html`
        <div class="stores">
            <div title="服務專員" class="service_man" v-for="oInfo in b2eInfo">
                <strong>
                    <span class="job_title">服務專員</span>
                    {{oInfo.ENP_NM}}
                </strong>
                <br />
                <a :href="'mailto:'+oInfo.email">{{oInfo.email}}</a>
                <div>{{oInfo.phone}}</div>
            </div>
        </div>
    `,
});
